import { useCheckAccountTraits } from '@cmg/auth';

export const useCheckInternalOfferingsTrait = () => {
  return useCheckAccountTraits(['INTERNAL_OFFERINGS']);
};
